// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.FrameRotation in videoConfig/videoconfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.EnumAdapter
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireEnum
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.JvmStatic
import kotlin.Int
import kotlin.Suppress

/**
 * Frame rotation. Represents frame  in degrees.
 */
public enum class FrameRotation(
  override val `value`: Int,
) : WireEnum {
  ROTATE_0(0),
  ROTATE_90(1),
  ROTATE_180(2),
  ROTATE_90_COUNTER_CLOCKWISE(3),
  ;

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<FrameRotation> = object : EnumAdapter<FrameRotation>(
      FrameRotation::class, 
      PROTO_3, 
      FrameRotation.ROTATE_0
    ) {
      override fun fromValue(`value`: Int): FrameRotation? = FrameRotation.fromValue(`value`)
    }

    @JvmStatic
    public fun fromValue(`value`: Int): FrameRotation? = when (`value`) {
      0 -> ROTATE_0
      1 -> ROTATE_90
      2 -> ROTATE_180
      3 -> ROTATE_90_COUNTER_CLOCKWISE
      else -> null
    }
  }
}
